import { css } from "@emotion/react";
import AeonikProFixedMedium from "@hl/base-components/lib/assets/fonts/AeonikProFixed/AeonikProFixed-Medium.woff";
import AeonikProFixedMedium2 from "@hl/base-components/lib/assets/fonts/AeonikProFixed/AeonikProFixed-Medium.woff2";
import AeonikProFixedRegular from "@hl/base-components/lib/assets/fonts/AeonikProFixed/AeonikProFixed-Regular.woff";
import AeonikProFixedRegular2 from "@hl/base-components/lib/assets/fonts/AeonikProFixed/AeonikProFixed-Regular.woff2";
import { MantineTheme } from "@mantine/core";

export const createCanvasCss = (theme: MantineTheme) => {
  const emptyStyles = `
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    min-height: 100px;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    /* background: ${theme.colors.gray[1]}; */
    color: ${theme.colors.gray[6]};
    text-overflow: ellipsis;
    white-space: pre-wrap;
    text-align: center;
    font-size: 14px;
    padding: 8px;
    border: 16px solid white;
  `;

  const canvasOnlyStyles = css`
    @font-face {
      font-family: "Aeonik Pro";
      src: url(${AeonikProFixedRegular2}) format("woff2"),
        url(${AeonikProFixedRegular}) format("woff");
      font-weight: 400;
      font-style: normal;
      font-display: auto;
    }

    @font-face {
      font-family: "Aeonik Pro";
      src: url(${AeonikProFixedMedium2}) format("woff2"),
        url(${AeonikProFixedMedium}) format("woff");
      font-weight: 500;
      font-style: normal;
      font-display: auto;
    }

    * {
      font-family: "Aeonik Pro", sans-serif;
      font-feature-settings: "ss02" on, "ss07" on, "ss09" on, "ss11" on,
        "cv10" on, "case" on;
      -webkit-font-smoothing: antialiased;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      line-height: 1.4;
      // font-size: 16px;
    }

    /*

    .gjs-dashed *[data-gjs-highlightable][data-gjs-highlightable] {
      outline: 1px dashed var(--selected-color, ${theme.colors.gray[4]});
    }
    .gjs-selected.gjs-selected {
      outline: 1px solid var(--selected-color, ${theme.colors
      .gray[9]}) !important;
    }
    */

    .hl-user-collected {
      .hl-user-collected-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;
        @media (min-width: ${theme.breakpoints.sm}px) {
          grid-template-columns: 1fr 1fr;
        }
        @media (min-width: ${theme.breakpoints.md}px) {
          grid-template-columns: 1fr 1fr 1fr;
        }
      }
    }
    /* Highlight Wrapper */
    .hl-wrapper {
      --selected-color: #ff9800;
      min-height: 100vh;
      min-width: 100vw;
      background: white;
    }
    .gjs-show-helpers {
      .box {
        padding: 16px;
        box-shadow: inset 0 0 0px 16px ${theme.colors.gray[1]};
      }
      .align {
        padding: 4px;
        box-shadow: inset 0 0 0px 4px ${theme.colors.yellow[3]};
      }
      .group {
        padding: 4px;
        box-shadow: inset 0 0 0px 4px ${theme.colors.orange[3]};
      }
      .simple-grid {
        padding: 4px;
        box-shadow: inset 0 0 0px 4px ${theme.colors.pink[3]};
      }
      .responsive-container {
        padding: 4px;
        box-shadow: inset 0 0 0px 4px ${theme.colors.green[3]};
      }
      .box-anchor {
        padding: 4px;
        box-shadow: inset 0 0 0px 4px ${theme.colors.gray[4]};
      }
    }

    .gjs-show-helpers .hl-wrapper:empty:after {
      content: "WELCOME! \\A Start building by dropping BOX-es here";
      ${emptyStyles}
      height: 100vh;
    }

    /* Simple Grid */
    .gjs-show-helpers .simple-grid:empty:after {
      content: "Drop BOX-es here";
      grid-column: 1 / -1;
      ${emptyStyles}
    }

    /*Responsive Container */
    .gjs-show-helpers .responsive-container:empty:before {
      content: "CONTAINER \\A Drop BOX-es here";
      ${emptyStyles}
    }
    /* Box */
    .gjs-show-helpers .box:empty:before {
      content: "BOX \\A Drop components here";
      ${emptyStyles}
    }
    /* Align */
    .align {
      --selected-color: #ff9800;
    }
    .gjs-show-helpers .align:empty:before {
      content: "ALIGN \\A Drop a BOX here";
      ${emptyStyles}
    }
    /* Anchor */
    .box-anchor {
      --selected-color: #ff9800;
    }
    .gjs-show-helpers .box-anchor:empty:before {
      content: "ANCHOR \\A Drop a BOX here";
      ${emptyStyles}
    }
  `;

  const exportedStyles = css`
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-family: "Aeonik Pro", sans-serif;
    }
  `;

  return {
    canvasOnlyStyles,
    exportedStyles,
  };
};
